var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useMutation } from '@apollo/client';
import paymentCardFragment from './PaymentCardFragment';
import { TEAM_ACCOUNT_PAYER_PAYMENT_METHOD_QUERY } from './usePaymentCardQuery';
export var DELETE_TEAM_ACCOUNT_PAYER_PAYMENT_METHOD_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation deletePaymentMethodByTeamAccount(\n    $teamAccountId: String!\n    $paymentMethodId: String!\n  ) {\n    deletePaymentMethodByTeamAccount(\n      teamAccountId: $teamAccountId\n      paymentMethodId: $paymentMethodId\n    ) {\n      ...PaymentCardFragment\n    }\n  }\n  ", "\n"], ["\n  mutation deletePaymentMethodByTeamAccount(\n    $teamAccountId: String!\n    $paymentMethodId: String!\n  ) {\n    deletePaymentMethodByTeamAccount(\n      teamAccountId: $teamAccountId\n      paymentMethodId: $paymentMethodId\n    ) {\n      ...PaymentCardFragment\n    }\n  }\n  ", "\n"])), paymentCardFragment);
export var useDeletePaymentCardMutation = function (teamAccountId, paymentMethodId, onCompleted, onError) {
    return useMutation(DELETE_TEAM_ACCOUNT_PAYER_PAYMENT_METHOD_MUTATION, {
        variables: {
            teamAccountId: teamAccountId,
            paymentMethodId: paymentMethodId,
        },
        onCompleted: onCompleted,
        onError: onError,
        refetchQueries: [
            {
                query: TEAM_ACCOUNT_PAYER_PAYMENT_METHOD_QUERY,
                variables: { teamAccountId: teamAccountId },
            },
        ],
        awaitRefetchQueries: true,
        fetchPolicy: 'network-only',
    });
};
var templateObject_1;
